<template>
  <div class="questionnaireHeader">
    <div class="questionnaireTitle">Cardio Questionnaire</div>
    <p class="text-center">
      To ensure your report comments are appropriate and your background is
      indicated to the provider accurately, please complete this questionnaire.
    </p>
    <div class="importantNote">
      <img
        class="mr-[10px]"
        alt="Important Note"
        src="@/assets/questionnaire/round_warning_mark.svg"
      />
      <p>
        <b>Important note:</b> Complete the optional questionnaire to view additional Framingham and Reynolds Risk Scores in your final report. If you have already filled out the emailed digital version, you DO NOT need to complete the printed version included with your kit.
      </p>
    </div>
    <p v-if="qnrIsCompleted" class="w-full text-center">
      <SimplifiedNotification
        :content="completedNotification"
        build_in_theme="blue"
        :with_close_btn="false"
      />
    </p>
  </div>
</template>

<script>
import SimplifiedNotification from "@/components/commons/SimplifiedNotification.vue";
import { useCardioQnrStore } from "@/stores/CardioQnrStore.ts";
import { mapState } from "pinia";
import { useWindowSize } from "@vueuse/core";

export default {
  name: "QuestionnaireHeader",
  components: {
    SimplifiedNotification,
  },
  setup() {
    const { width } = useWindowSize();
    return {
      width,
    };
  },

  computed: {
    ...mapState(() => useCardioQnrStore(), ["qnrIsCompleted"]),
    dynamic_font_size() {
      return this.width <= 808 ? "12px" : "16px";
    },
    completedNotification() {
      return (
        "<span class='text-[" +
        this.dynamic_font_size +
        "]'><b>Read-only:</b>The questionnaire has been submitted. Please <a class='text-[#20a8c3]' href='https://www.vibrant-wellness.com/Contact'>Contact Support</a> to make any changes. </span>"
      );
    },
  },
};
</script>

<style scoped>
.questionnaireHeader {
  width: 840px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.questionnaireTitle {
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.175px;
  color: #0e4672;
  margin-bottom: 18px;
}

.questionnaireHeader p {
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.175px;
  color: #0e4672;
}

.importantNote {
  background: #faece6;
  border-radius: 4px;
  min-height: 65px;
  height: fit-content;
  margin: 18px 0;
  padding: 12px;
  display: flex;
  align-items: center;
}

.importantNote b {
  font-weight: 700;
}

@media only screen and (max-width: 808px) {
  .questionnaireHeader {
    width: 358px;
  }

  .questionnaireTitle {
    font-size: 18px;
    margin-bottom: 6px;
  }

  .questionnaireHeader p {
    font-size: 14px;
  }

  .importantNote {
    min-height: 65px;
    margin: 14px 0;
    padding: 8px;
  }

  .thanksMessage {
    display: none;
  }
}
</style>
